// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cognito_identity_pool_id": "ap-southeast-2:09a57bf1-0b6a-439a-b944-69dc6394fa95",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_fSLKpj7g5",
    "aws_user_pools_web_client_id": "43lan1gnp4efgoptusqhk0p5lk",
    "oauth": {},
    "aws_content_delivery_bucket": "dcm-client-v1-website-dev",
    "aws_content_delivery_bucket_region": "ap-southeast-2",
    "aws_content_delivery_url": "https://d3r70g7fc8myhb.cloudfront.net",
    "aws_user_files_s3_bucket": "dcm-client-v1-bucket-dev",
    "aws_user_files_s3_bucket_region": "ap-southeast-2"
};


export default awsmobile;
